export type SetupType = 'hybrid' | 'peakshave_grid' | 'loadshare_grid' | 'grid_boost' | 'grid_boost_genset';

export const setupTypeTranslationKeys: Record<SetupType, string> = {
  hybrid: 'blueprints:details.proposedSolution.setupTypes.hybrid',
  peakshave_grid: 'blueprints:details.proposedSolution.setupTypes.peakshave_grid',
  loadshare_grid: 'blueprints:details.proposedSolution.setupTypes.loadshare_grid',
  grid_boost: 'blueprints:details.proposedSolution.setupTypes.grid_boost',
  grid_boost_genset: 'blueprints:details.proposedSolution.setupTypes.grid_boost_genset',
};
